<template>
  <div class="cases-data-view container">
    <nav-bar />

    <div class="outer-container gray-3 bg">
      <side-nav />

      <div class="caselist-container">
        <case-list
          :user="user"
          :org-data="orgData"
          :validate-case-conf-by-id="validateCaseConfById"
          @previewCase="caseConf => previewCase(caseConf)"
          @fetchErrorsChanged="errors => fetchErrorsChanged(errors)"
        />
      </div>

      <case-preview
        v-if="state.previewedCase"
        :key="state.previewedCase.id"
        :case-conf="state.previewedCase"
        :user="user"
        :org-data="orgData"
        @load="caseConf => loadCase(caseConf.id)"
        @remove="caseConf => $eventHub.$emit('CASE::REMOVE', caseConf)"
        @run="(caseConf, orgId, assignment) => runCase(caseConf.id, orgId, assignment)"
        @duplicate="(caseConf, newCaseName) => $eventHub.$emit('CASE::DUPLICATE', caseConf, newCaseName)"
        @favorite="caseConf => $eventHub.$emit('CASE::FAVORITE', caseConf)"
        @openGrades="caseConf => openGrades(caseConf)"
        @update="caseConf => $eventHub.$emit('CASE::UPDATE', caseConf)"
      />
    </div>

    <bottom-bar
      :can-create-case="canCreateCase"
      :is-student="isStudent"
      @newCase="newCase()"
      @showTutorials="showTutorials"
    />

    <md-drawer
      class="tutorial-drawer"
      :md-active.sync="state.tutorialDrawerOpen"
      @md-closed="closeTutorialDrawer"
    >
      <tutorial-list
        v-if="state.tutorialDrawerOpen"
        :category="state.tutorialDrawerCategory"
        :product-type="user.productType"
        @close="closeTutorialDrawer"
      />
    </md-drawer>
  </div>
</template>

<script>
import SideNav from '~lib/common/components/SideNav';
import NavBar from '~lib/common/components/NavBar';
import CaseList from '~lib/common/components/CaseList';
import TutorialList from '~lib/common/components/Tutorials/TutorialList.vue';

import { validateCaseConfById } from '~lib/common/validators/validateCaseConf';

import BottomBar from './common/BottomBar.vue';
import CasePreview from './overview/CasePreview';

import getWebglLink from '../utils/getWebglLink';

export default {
  name: 'cases-data-view',
  components: {
    CaseList,
    BottomBar,
    TutorialList,
    SideNav,
    NavBar,
    CasePreview,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    orgData: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      validateCaseConfById,
      state: {
        previewedCase: null,
        fetchErrors: [],
        tutorialDrawerOpen: false,
        tutorialDrawerCategory: null,
      },
    };
  },
  computed: {
    isStudent() {
      return this.user.activeRole === 'STUDENT';
    },
    canCreateCase() {
      return !this.isStudent && !this.state.fetchErrors.length;
    },
  },
  mounted() {
  },
  methods: {
    previewCase(caseConf) {
      this.state.previewedCase = caseConf;
    },
    loadCase(id) {
      this.$emit('load', id);
    },
    runCase(caseId, orgId, assignment) {
      let webglLink = getWebglLink(caseId, orgId);
      if (assignment) {
        webglLink += `&assignment=${assignment.id}`;
      }
      window.open(webglLink, '_blank');
    },
    openGrades(caseConf) {
      this.$router.push({
        name: 'grades',
        params: {
          id: caseConf.id,
        },
        query: {
          caseName: caseConf.name,
        },
      });
    },
    newCase() {
      this.$emit('newCase');
      const groupsData = this.user['https://vrpatients.com/groupsData'];
      if (!groupsData) {
        return;
      }
      const orgGroup = groupsData[0];
      if (!orgGroup) {
        return;
      }
      this.$analytics.event('Case List', 'create new case', orgGroup.name);
    },
    showTutorials(category) {
      this.state.tutorialDrawerCategory = category;
      this.state.tutorialDrawerOpen = true;
    },
    closeTutorialDrawer() {
      this.state.tutorialDrawerOpen = false;
    },
    fetchErrorsChanged(errors) {
      this.state.fetchErrors = errors;
    }
  },
};
</script>

<style scoped>
.cases-data-view {
  display: flex;
  flex-direction: column;
  position: relative;
}

.outer-container {
  flex: 1 0 0;
  display: flex;
  flex-direction: row;
  height: calc(100% - 153px);
  overflow-x: auto;
}

.caselist-container {
  padding: 20px 25px;
  flex: 2;
  will-change: transform;
  float: left;
  min-width: 500px;
}

.side-nav {
  width: 15%;
}

.container {
  will-change: transform;
  height: 100%;
}

.tutorial-drawer {
  min-width: 600px;
}
</style>
